"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.setAnalyticsLoggingEnabled = exports.getLogger = void 0;
var loglevel_1 = __importDefault(require("loglevel"));
var isEnabled = false;
var analyticsLoggers = new Map();
function getLogger(name) {
    var logger = analyticsLoggers.get(name);
    if (logger === undefined) {
        logger = loglevel_1["default"].getLogger(PREFIX + name);
        logger.setDefaultLevel(loglevel_1["default"].levels.SILENT);
        if (isEnabled) {
            logger.setLevel(loglevel_1["default"].levels.DEBUG);
        }
        analyticsLoggers.set(name, logger);
    }
    return logger;
}
exports.getLogger = getLogger;
function setAnalyticsLoggingEnabled(enabled) {
    var e_1, _a;
    isEnabled = enabled;
    try {
        for (var _b = __values(analyticsLoggers.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var logger = _c.value;
            if (isEnabled) {
                logger.setLevel(loglevel_1["default"].levels.DEBUG);
            }
            else {
                logger.resetLevel();
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
exports.setAnalyticsLoggingEnabled = setAnalyticsLoggingEnabled;
var PREFIX = "Analytics.";
//# sourceMappingURL=logger.js.map